import { loadOnboardingState } from '@/composables/useOnboardingWizardState';

/** Require registration draft in session before entering onboarding steps. */
export function onboardingRequiresAccount(to, from, next) {
  const s = loadOnboardingState();
  if (!s?.account?.email) {
    next({ path: '/register' });
    return;
  }
  next();
}
